import React from "react";
import styles from "./Privacy.module.css";

const Privacy = () => {
  return (
    <div className={styles.container}>   
    <section className={styles.privacySection}>
      <h1>
        Beyond Baptism Privacy Statement
      </h1>

      <p>
        <strong>Effective Date: </strong>August 15, 2025
      </p>

      <p>
        Beyond Baptism (“we,” “our,” “us”) values your privacy and is committed to protecting the personal information you share with us through our website, events, and ministry activities. This Privacy Statement explains how we collect, use, and safeguard your information.
      </p>

      <div>

      <div>
        <h4>
            1. Information We Collect
        </h4>
        <p>
            We may collect the following information when you interact with our website or ministry:
            <ul>
                <li>
                    <b>Personal Information</b> you provide voluntarily, such as your name, email address, phone number, parish affiliation, or mailing address.
                </li>
                <li>
                    <b>Event Registration Information</b>, including your participation history and preferences.
                </li>
                <li>
                    <b>Non-Personal Information</b>, such as browser type, device type, and website usage statistics, collected automatically through cookies or similar technologies.
                </li>
            </ul>
        </p>
      </div>

      <div>
        <h4>
            2. How We Use Your Information
        </h4>
        <p>
            We use your information only for ministry purposes, including:
            <ul>
                <li>
                    Communicating with you about events, updates, and opportunities to participate in Beyond Baptism activities
                </li>
                <li>
                    Processing registrations, volunteer applications, and donations.
                </li>
                <li>
                    Providing spiritual and educational resources related to our mission.
                </li>
                <li>
                    Improving our website, outreach, and ministry programs.
                </li>
            </ul>
            <p>We <b>do not</b> sell, rent, or trade your personal information to third parties.</p>
        </p>
      </div>

      <div>
        <h4>
            3. Sharing Your Information
        </h4>
        <p>
            We may share your information:
            <ul>
                <li>
                    With trusted ministry partners, clergy, or volunteers who assist with Beyond Baptism activities
                </li>
                <li>
                    When required by law or to protect our legal rights.
                </li>
            </ul>
            <p>All ministry partners and volunteers are expected to maintain the confidentiality of your information.</p>
        </p>
      </div>

      <div>
        <h4>
            4. Security of Your Information
        </h4>
        <p>
            We take reasonable administrative, technical, and physical measures to protect your personal information against unauthorized access, disclosure, alteration, or misuse.
        </p>
      </div>

      <div>
        <h4>
            5. Your Choices
        </h4>
        <p>
            You may:
            <ul>
                <li>
                    Opt out of receiving email communications by following the “unsubscribe” link in our messages.
                </li>
                <li>
                    Request access, correction, or deletion of your personal information by contacting us at <a href="mailto:admin@beyondbaptism.com"><strong>admin@beyondbaptism.com</strong></a>.
                </li>
            </ul>
        </p>
      </div>

      <div>
        <h4>
            6. Children’s Privacy
        </h4>
        <p>
            Our website and events are intended for a general audience. We do not knowingly collect personal information from children under 13 without parental consent.
        </p>
      </div>

      <div>
        <h4>
            7. Changes to This Privacy Statement
        </h4>
        <p>
            We may update this Privacy Statement from time to time. Changes will be posted on this page with a revised effective date.
        </p>
      </div>

      <div>
        <h4>
            8. Contact Us
        </h4>
        <p>
            If you have questions about this Privacy Statement or our privacy practices, please contact:<br />
            <strong>Beyond Baptism Ministry</strong><br />
            Email: <a href="mailto:admin@beyondbaptism.com"><strong>admin@beyondbaptism.com</strong></a><br />
            Mailing Address: <strong>169 Holmes Street, Belleville, NJ 07109</strong>
        </p>
      </div>

      </div>

    </section>
    </div>
  );
};

export default Privacy;
